module.exports = __webpack_public_path__ + "8f6b3de1fcf3d6c86586f767c6573368.svg";